module.exports = __webpack_public_path__ + "img/Cover View - 2.7102f385.svg";